<template>
  <v-container>

    <template v-if="tours.length">

      <v-data-table
        :headers="headers"
        :items="tours"
        :options.sync="options"
        :items-per-page="15"
        :server-items-length="totalTours"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-btn plain color="primary" :to="`/exhibitions/${exhibitionId}/tours/new`">
            {{ $t('tours.list.newTour') }}
          </v-btn>
        </template>

        <template v-slot:item.open="{ item }">
          <v-btn icon small :to="`/exhibitions/${exhibitionId}/tours/${item.id}`" >
            <v-icon>
              mdi-eye
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            class="mr-2"
            :to="`/exhibitions/${exhibitionId}/tours/${item.id}/update`">
            <v-icon
              small
            >
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-icon
            small
            @click="deleteTour(item)"
          >
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:item.createdAt="{ item }">
          <span>{{ new Date(item.createdAt).toLocaleString() }}</span>
        </template>

        <template v-slot:item.updatedAt="{ item }">
          <span>{{ new Date(item.updatedAt).toLocaleString() }}</span>
        </template>
      </v-data-table>

    </template>

    <template v-else>
      <v-row justify="center" align="center" class="max-height">
        {{ $t('tours.list.noTour') }}
        <v-btn plain color="primary" :to="`/exhibitions/${exhibitionId}/tours/new`">
          {{ $t('tours.list.newTour') }}
        </v-btn>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import i18n from '@/i18n';

export default {
  name: 'TourListPage',
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {},
      exhibitionId: this.$route.params.id,
    };
  },
  created() {
    this.getDataFromApi();
  },
  computed: {
    tours() {
      return this.$store.state.tour.tours;
    },
    totalTours() {
      return this.$store.state.tour.totalTours;
    },
    loading() {
      return this.$store.state.tour.loading;
    },
    language() {
      return this.$i18n.locale;
    },
    headers() {
      return [
        {
          text: i18n.t('tours.list.open'),
          value: 'open',
          sortable: false,
        },
        {
          text: i18n.t('tours.list.name'),
          value: `name.${this.language}`,
          sortable: false,
        },
        {
          text: i18n.t('tours.list.createdAt'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: i18n.t('tours.list.updatedAt'),
          value: 'updatedAt',
          sortable: false,
        },
        { text: i18n.t('tours.list.actions'), value: 'actions', sortable: false },
      ];
    },
  },
  methods: {
    getDataFromApi() {
      const {
        page, itemsPerPage,
      } = this.options;
      this.$store.dispatch('tour/listTours', {
        page,
        itemsPerPage,
        exhibitionId: this.$route.params.id,
      });
    },

    async deleteTour({ id, name }) {
      if (await this.$root.$confirm.open(
        i18n.t('common.delete'),
        i18n.t('tours.deleteConfirm'),
        { color: 'red', itemName: name[this.language] },
      )) {
        await this.$store.dispatch('tour/deleteTour', {
          id,
          exhibitionId: this.$route.params.id,
        });

        // If the removed item was the last one in the page we need to go to the previous page
        if (this.tours.length - 1 <= 0 && this.options.page > 1) {
          this.options.page -= 1;
        }

        this.getDataFromApi();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  .max-height {
    height: 100%;
  }
}
</style>
